<div class="m-1 py-0.5 px-2.5 rounded-full text-sm font-medium text-center"
     [ngClass]="labelColorConfig.combined">
    <span class="line-clamp-2">{{ config.label }}</span>
</div>
